import { WORKSPACE_AGENT_MESSAGE_ROW_GAP_PX } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentMessageRowLayout';
import { type WorkspaceAgentMessageRowPills } from '~/components/v2/components/workspace/workspace-agent-panel/utils/buildWorkspaceAgentMessageRowPills';
import { type WorkspaceAgentDisplayRow } from '~/components/v2/components/workspace/workspace-agent-panel/utils/groupWorkspaceAgentMessagesForDisplay';

const ESTIMATED_USER_MESSAGE_HEIGHT_PX = 56;
const ESTIMATED_ASSISTANT_MESSAGE_HEIGHT_PX = 120;
const ESTIMATED_RUN_GROUP_HEIGHT_PX = 48;
/** Matches `PrivateMessageUncitedAssetScope` scope bar height (`py-1.5` + one line). */
const ESTIMATED_UNCITED_PILL_ROW_HEIGHT_PX = 40;

export const estimateWorkspaceAgentMessageRowSize = (
  row: WorkspaceAgentDisplayRow,
  rowPills: WorkspaceAgentMessageRowPills,
): number => {
  const rowGap = WORKSPACE_AGENT_MESSAGE_ROW_GAP_PX;

  if (row.type === 'runGroup') {
    return ESTIMATED_RUN_GROUP_HEIGHT_PX + rowGap;
  }

  if (row.type === 'elicitationAnswer') {
    return ESTIMATED_USER_MESSAGE_HEIGHT_PX + rowGap;
  }

  const showsStack = rowPills.showUncitedAssetPreview;
  const showsBubble = rowPills.displayHasBubble;
  let bubbleHeight = 0;

  if (showsBubble) {
    bubbleHeight =
      row.message.role === 'user' ? ESTIMATED_USER_MESSAGE_HEIGHT_PX : ESTIMATED_ASSISTANT_MESSAGE_HEIGHT_PX;
  }

  const stackHeight = showsStack ? ESTIMATED_UNCITED_PILL_ROW_HEIGHT_PX : 0;
  // The measured row is `flex-col gap-3 pb-3`. The padding is the gap before the next row.
  const stackToBubbleGap = showsStack && showsBubble ? WORKSPACE_AGENT_MESSAGE_ROW_GAP_PX : 0;

  return bubbleHeight + stackHeight + stackToBubbleGap + rowGap;
};
